'use client'

import type { GradingProvider } from '../lib/types'
import { ProviderLogo } from './icons'
import styles from './report.module.css'

export function ProviderTabs({
  providers,
  selected,
  onSelect,
}: {
  providers: GradingProvider[]
  selected: GradingProvider
  onSelect: (p: GradingProvider) => void
}) {
  if (providers.length < 2) return null
  return (
    <div className={styles.tabs} role="tablist" aria-label="Grading provider">
      {providers.map((p) => (
        <button
          key={p}
          role="tab"
          aria-selected={p === selected}
          className={`${styles.tab} ${p === selected ? styles.tabActive : ''}`}
          onClick={() => onSelect(p)}
        >
          <ProviderLogo provider={p} height={13} />
        </button>
      ))}
    </div>
  )
}
